import React from 'react'

import { Icon } from '@octane/spark'
import useGoogleTagManager from 'hooks/useGoogleTagManager'
import './NavbarItem.css'

const ICON_SIZE = 21

export enum UrlMatchType {
    Exact,
    StartsWith,
}

export interface NavbarItemProps {
    id: string
    href: string
    text: string
    iconName: string
    urlMatchType: UrlMatchType
}

const isHrefActive = (href: string, urlMatchType: UrlMatchType) => {
    switch (urlMatchType) {
        case UrlMatchType.Exact:
            return href === window.location.hash

        case UrlMatchType.StartsWith:
            return window.location.hash.startsWith(href)

        default:
            return false
    }
}

export default function NavbarItem({
    id,
    href,
    iconName,
    text,
    urlMatchType,
}: NavbarItemProps): JSX.Element {
    const isActive = isHrefActive(href, urlMatchType)
    const googleTagManager = useGoogleTagManager()

    return (
        <li className={`NavbarItem ${isActive ? 'active' : ''}`}>
            <a
                href={href}
                id={id}
                className={isActive ? 'active' : ''}
                onClick={() => {
                    googleTagManager.trackNavbarEvent(text, href)
                }}
            >
                <Icon icon={iconName} width={ICON_SIZE} height={ICON_SIZE} />
                <span className="Navbar-nav-label">{text}</span>
            </a>
        </li>
    )
}

NavbarItem.UrlMatchType = UrlMatchType
